export const SupplementaryValueTypes = {
    TEXT : 'Text',
    DATE : 'Date',
    YES_NO : 'YesOrNo',
    NUMBER : 'Number'
}